(
    function (skyward, $)
    {
        "use strict";

        skyward.autoSaveManagers = skyward.autoSaveManagers || {};

        var defaultUndoManagerSettings =
        {
            execute: function (/* status object */)
            {
                // Called when a new command is executed and added to the undo manager
            },
            undo: function (/* status object */)
            {
                // Called when a command is undone
            },
            redo: function (/* status object */)
            {
                // Called when a command is redone
            },
            reset: function (/* status object */)
            {
                // called when the undo manager's command list is cleared
            }
        };

        var defaultCommand =
        {
            execute: function ()
            {
                // Called whenever a command is executed or on a redo
            },
            undo: function ()
            {
                // Called whenever a command is undone
            }
        };

        // The undo manager handles undo/redo functionality. Commands must be pushed into the manager by calling the execute method
        // and passing in an object that contains execute() and undo() functions.
        skyward.autoSaveManagers.createUndoManager = function (options)
        {
            var undoManager = {};
            var settings = $.extend({}, defaultUndoManagerSettings, options);

            var position = -1;
            var commands = [];

            var getStatus = function ()
            {
                var status =
                {
                    position: position + 1,
                    totalCommands: commands.length,
                    canUndo: undoManager.canUndo(),
                    canRedo: undoManager.canRedo()
                };

                return status;
            };

            undoManager.execute = function (command)
            {
                command = $.extend({}, defaultCommand, command);
                commands.splice(position + 1, Number.MAX_VALUE);
                position++;
                commands.push(command);
                var result = commands[position].execute();
                settings.execute(getStatus());

                return result;
            };

            undoManager.undo = function ()
            {
                var result = null;

                if (undoManager.canUndo())
                {
                    result = commands[position].undo();
                    position--;
                }

                settings.undo(getStatus());
                return result;
            };

            undoManager.redo = function ()
            {
                var result = null;

                if (undoManager.canRedo())
                {
                    position++;
                    result = commands[position].execute();
                }
                
                settings.redo(getStatus());
                return result;
            };

            undoManager.reset = function ()
            {
                position = -1;
                commands = [];
                settings.reset(getStatus());
            };

            undoManager.canUndo = function ()
            {
                return commands.length > 0 && position >= 0;
            };

            undoManager.canRedo = function ()
            {
                return commands.length > 0 && position + 1 < commands.length;
            };

            return undoManager;
        };

        var defaultSaveManagerSettings =
        {
            saveDataUniqueId: "saveManagerId", // The property name for the save manager to see if one piece of data is the same as another
            postDataAttributeName: "saveData", // The property name all the save data will be attached to when posted
            savesStarted: function (/* status object */)
            {
                // Called when a save starts
            },
            update: function (/* status object */)
            {
                // Called when a save is added or completed
            },
            savesCompleted: function (/* status object */)
            {
                // Called when all saves are completed
            }
        };

        // The save manager ensures that new saves updating data with the same saveManagerId wait for existing saves to finish
        // before firing. This is to prevent race conditions since we can't be certain which order the server will handle the
        // AJAX requests. This works with both updating a single piece of data or a batch in an array. Objects being passed in
        // must have a saveManagerId attribute for this to work properly.
        skyward.autoSaveManagers.createSaveManager = function (options)
        {
            var saveManager = {};
            var settings = $.extend({}, defaultSaveManagerSettings, options);

            var saveTracker = (function ()
            {
                var saveTracker = {};

                var saveInProgress = false;
                var queue = [];
                var requestsComplete = 0;

                var reset = function ()
                {
                    saveInProgress = false;
                    queue = [];
                    requestsComplete = 0;
                };

                var getNumberOfCurrentRequests = function ()
                {
                    var count = 0;

                    for (var i = 0; i < queue.length; i++)
                    {
                        if (queue[i].state() == "pending")
                        {
                            count++;
                        }
                    }

                    return count;
                };

                var getStatus = function ()
                {
                    var status =
                    {
                        numberOfCurrentRequests: getNumberOfCurrentRequests(),
                        numberOfCompletedRequests: requestsComplete,
                        numberOfTotalRequests: queue.length
                    };

                    return status;
                };

                saveTracker.add = function (request)
                {
                    if (!saveInProgress)
                    {
                        saveInProgress = true;
                        settings.savesStarted(getStatus());
                    }

                    queue.push(request);

                    request.then(function ()
                    {
                        requestsComplete++;
                        settings.update(getStatus());

                        if (requestsComplete == queue.length)
                        {
                            settings.savesCompleted(getStatus());
                            reset();
                        }
                    });
                };

                return saveTracker;
            })();

            var dataTracker = (function ()
            {
                var dataTracker = {};

                var queue = [];

                dataTracker.remove = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        for (var j = queue.length - 1; j > -1; j--)
                        {
                            if (queue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId] && queue[j].request === promise)
                            {
                                queue.splice(j, 1);
                            }
                        }
                    }
                };

                dataTracker.add = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        var queueData = {};
                        queueData[settings.saveDataUniqueId] = data[i][settings.saveDataUniqueId];
                        queueData.request = promise;
                        queue.push(queueData);
                    }
                };

                dataTracker.getQueue = function ()
                {
                    return queue.slice();
                };

                return dataTracker;
            })();

            var findConflictingSavesInProgress = function (data)
            {
                var conflicts = [];
                var dataQueue = dataTracker.getQueue();

                for (var i = 0; i < data.length; i++)
                {
                    for (var j = 0; j < dataQueue.length; j++)
                    {
                        if (dataQueue[j] && dataQueue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId])
                        {
                            conflicts.push(dataQueue[j].request);
                        }
                    }
                }

                return conflicts;
            };

            var queueSave = function (data, url)
            {
                var deferred = $.Deferred();
                var promise = deferred.promise();
                var waitFor = findConflictingSavesInProgress(data);

                $.when.apply($, waitFor).then(function ()
                {
                    var postData = {};
                    postData[settings.postDataAttributeName] = JSON.stringify(data);

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + url,
                        type: "POST",
                        dataType: "JSON",
                        data: postData,
                        activityIndicator: { silent: true },
                        success: function ()
                        {
                            deferred.resolve.apply(this, arguments);
                            dataTracker.remove(data, promise);
                        }
                    });
                });

                dataTracker.add(data, promise);
                saveTracker.add(promise);

                return promise;
            };

            saveManager.save = function (data, url)
            {
                if (!Array.isArray(data))
                {
                    data = [data];
                }

                return queueSave(data, url);
            };

            return saveManager;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);